interface IsinValidatable {
  isin?: string;
  hasValidIsin?: boolean;
  quoteProvider?: string;
}

export const useIsinValidation = (item: IsinValidatable) => {
  const isCrypto = item.quoteProvider === "crypto";
  const isIsinValid =
    isCrypto || (Boolean(item.isin?.length) && Boolean(item.hasValidIsin));

  return { isIsinValid };
};

export const isIsinError = (error: AxiosApiError | null): boolean => {
  const errors = error?.response?.data?.errors ?? [];

  return errors.some(
    ({ code, message }) =>
      code === "VALIDATION_ERROR" && message?.toUpperCase().includes("ISIN")
  );
};
